/*global google*/
import React, { useState, useEffect } from "react";
import { MarkerClusterer as GoogleMapMarkerClusterer } from "@googlemaps/markerclusterer";

const MarkerClusterer = ({ markerOptions, map, maxZoom }) => {
  /**
   * @type {[GoogleMapMarkerClusterer]} markerClusterer
   */
  const [markerClusterer, setMarkerClusterer] = useState();

  useEffect(() => {
    if (!markerClusterer && map) {
      // Add a marker clusterer to manage the markers.
      const newMarkerClusterer = new GoogleMapMarkerClusterer({
        map,
        // imagePath: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m',
        onClusterClick: (event, cluster, m) => {
          if (map.getZoom() === maxZoom) {
            var infowindow = new google.maps.InfoWindow({
              content: "<p>There are " + cluster.markers.length + " listings in this area.</p><div style='text-align: center'><a class='btn btn-green' onclick='" +
                "const parameters = new URLSearchParams(window.location.search);" +
                'parameters.set("zip", ' + cluster.markers[0].zip + ');' +
                'parameters.set("location", "");' +
                'window.location.href = `${window.location.pathname}?${parameters.toString()}`;' +
                "' style='font-size: 90%; padding: 5px;'>See Listings</a></div>",
              position: cluster.markers[0].position
            });
            infowindow.open(map);
          }
        },
      });

      setMarkerClusterer(newMarkerClusterer);
    }
  }, [map, markerClusterer, maxZoom]);

  useEffect(() => {
    let markers;

    if (markerClusterer) {
      markerClusterer.clearMarkers();
      const infoWindow = new google.maps.InfoWindow();

      const bound = new google.maps.LatLngBounds();
      markers = markerOptions.map(({ infoContent, ...option }) => {
        const marker = new google.maps.Marker({ ...option, map, label: '' });

        // markers can only be keyboard focusable when they have click listeners
        // open info window when marker is clicked
        marker.addListener("click", () => {
          infoWindow.setContent(infoContent);
          infoWindow.open(map, marker);
        });

        bound.extend(
          new google.maps.LatLng(option.position.lat, option.position.lng)
        );

        return marker;
      });

      // Add some markers to the map.
      markerClusterer.addMarkers(markers);

      map.fitBounds(bound);

      const zoom = map.getZoom();
      map.setZoom(zoom > 6 ? 6 : zoom);
    }

    // remove marker from map on unmount
    return () => {
      if (markerClusterer) {
        markerClusterer.clearMarkers();
      }
    };
  }, [map, markerClusterer, markerOptions]);

  return <React.Fragment />;
};

export default MarkerClusterer;
